import {createSelector} from 'reselect';
import lodash from 'lodash';

export const getReasons = state => lodash.get(state, 'ViolateReasons.list', []);

export const getActiveReasons = createSelector(
    getReasons,
    reasons => lodash.filter(reasons, {status: 'ACTIVE'})
);
